export enum FeatureFlagEnum {
    showAllCalendarDates = "show-all-calendar-dates",
    whiteLabeling = "white-labeling",
    leafTemperature = "leaf-temperature",
    sugarCaneLayer = "sugar-cane-layer",
    cortevaCornSeedCrops = "corteva-corn-seed-crops",
}
